import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useRudderStack } from '../../lib/rudderStack/useRudderStack';
import { ModalSurveyController } from '../Survey/modal-survey.controller';
import { SanitizedSurvey } from '../../modules/survey/survey.types';

export const surveyModalPath = '/survey';

// TODO rename
const ModalSurveyControllerWithModalContext = NiceModal.create(ModalSurveyController);

export const useModalSurvey = () => {
  const { triggerLocation } = useRudderStack();
  const { show } = useModal(ModalSurveyControllerWithModalContext);

  return useCallback(
    (survey: SanitizedSurvey) => {
      triggerLocation(surveyModalPath);
      show({ sanitizedSurvey: survey, onClose: () => triggerLocation() });
    },
    [triggerLocation, show],
  );
};
